export default "__VITE_ASSET__Dqkfx9st__"